import * as React from 'react';
import { Expand } from '../../Expand/Expand';
import { Styler, StylerBaseProps } from '../../Styler/Styler';
import { useAccordionContext } from '../Accordion.context';
import { useStyles } from './AccordionContent.styles';

export interface AccordionContentProps extends StylerBaseProps {
    /**
     * The content of the component.
     */
    children: React.ReactNode;
}

export function AccordionContent(props: Readonly<AccordionContentProps>): React.JSX.Element {
    const { children, onClick, LabelProps, ref, ...other } = props;

    const { headerId, contentId, expanded, transitionDuration } = useAccordionContext();

    const { styles } = useStyles();

    return (
        <Expand in={expanded} timeout={transitionDuration}>
            <Styler
                ref={ref}
                baseStyles={styles.panel}
                id={contentId}
                aria-labelledby={headerId}
                role="region"
                data-accordion-content={true}
                {...other}
            >
                {children}
            </Styler>
        </Expand>
    );
}
